export default __webpack_public_path__ + "static/media/shipping-management-2.181821f0.svg";